import React from 'react';

import PurchaseHistory from 'billing/purchases/PurchaseHistory';
import history_icon from 'common/img/history_icon.svg';

export const PurchaseHistoryScreen = () => {
  return (
    <div className="PurchaseHistory">
      <h1>
        Invoice History
        <img src={history_icon} alt="" />
      </h1>
      <PurchaseHistory />
    </div>
  );
}

export default PurchaseHistoryScreen;
